import { api } from '@services';

import Auth0User, {
  IAuth0User,
  IAuth0UserApiModel,
} from '@models/Auth0User.model';

interface IRequest {
  equipmentId: string;
}

const getEquipmentStatusAuthor = async ({
  equipmentId,
}: IRequest): Promise<IAuth0User | undefined> => {
  const { data: auth0User } = await api.get<IAuth0UserApiModel | undefined>(
    `/equipments/${equipmentId}/statusAuthor`,
  );
  if (auth0User) return Auth0User.fromApiModel(auth0User);
  return undefined;
};

export { getEquipmentStatusAuthor };
